import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';

import './Header.scss';

type Props = {
    nombreSeccion?: string
}

const Header = ({nombreSeccion = 'INICIO'}: Props) => {

    const subtitulo: string = "Albergue de Griegos";
    const descripcion: string = "Situado a 1604 metros, en plena Sierra de Albarracín"
    
    const itemsMenu : string[] = ["habitaciones", "entorno", "actividades", "conocenos", "contacto"];

    // "rutas",

    const {hash, key} = useLocation()
    useEffect(() => {
        let targetElement = document.getElementById("inicio")
        if(hash){
            targetElement = document.getElementById(hash.substring(1))
        }
        targetElement?.scrollIntoView({behavior: 'smooth'})
    }, [key, hash])

    const generarItemsMenu = () => {

        return itemsMenu.map((itemMenu: string, index: number ) => {

            let paramsPath = {pathname: "/", hash: "#" + itemMenu};
            if (itemMenu === 'rutas') {
                paramsPath = {pathname: "/rutas", hash: ""};
            }

            const cerrarMenu = () => {

                const targetElement = document.getElementById("navbarResponsive");
                if (targetElement) {
                    targetElement.classList.remove("show");
                }           
                
            }

            return (
                <li className="nav-item mx-0 mx-lg-1" key={index}>
                    <Link className="nav-link py-3 px-0 px-lg-3 rounded" to={paramsPath} onClick={cerrarMenu} >
                        { itemMenu }
                    </Link>
                </li>
            )
        })

    }

    const generarMenu = () => {

        return (
            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ms-auto">
                    { generarItemsMenu() }
                </ul>
            </div>
        )

    }

    const generarNavBar = () => {

        return (
            <nav className="navbar navbar-expand-lg bg-light text-uppercase fixed-top" id="mainNav">
                <div className="container">

                    <a className="navbar-brand" href="/#inicio">
                        <img src='/img/logo.png' alt='logo albergue' />
                    </a>

                    <button className="navbar-toggler text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        Menu
                        <i className="fas fa-bars"></i>
                    </button>

                    {
                        generarMenu()
                    }
                    
                </div>
            </nav>
        )
    }

    const generarHeaderHome = () => {
        
        return (
            <header className="masthead text-white bg-primary imagenFondo">

                <div className="container masthead__container d-flex justify-content-center align-items-center flex-column">

                    <h1 className="masthead-heading text-uppercase mb-0 text-center">
                        { subtitulo }
                    </h1>
                    
                    <div className="divider-custom divider-light">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon">
                            <i className="fas fa-home"></i>
                        </div>
                        <div className="divider-custom-line"></div>
                    </div>
                    
                    <p className="masthead-subheading font-weight-light mb-0 text-center">
                        { descripcion }
                    </p>
                </div>
                
            </header>
        )
    }

  return (
    <>
        {
            generarNavBar()
        }

        {
            (nombreSeccion === 'INICIO')?generarHeaderHome():<></>
        }

    </>
  )
}

export default Header